import React from 'react';

import { DurationUnit } from '@occc-app/lib/date';
import { useChainId } from '@occc-app/Chain/hooks';

import { AudienceSizeChart } from './AudienceSizeChart';

import { useGetAudienceMetricsById } from '../../../../dataAccessLayer/audience/useGetAudienceMetricsById';

interface IAudienceSizeChartContainerProps {
  audienceId: string;
  startDate: string;
  endDate: string;
  interval: DurationUnit;
}

export const AudienceSizeChartContainer: React.FC<IAudienceSizeChartContainerProps> = ({
  audienceId,
  startDate,
  endDate,
  interval,
}) => {
  const chainId = useChainId();
  const { error, loading, data } = useGetAudienceMetricsById(
    audienceId,
    startDate,
    endDate,
    chainId,
  );
  return (
    <AudienceSizeChart
      data={data?.dailyCounts}
      loading={loading}
      error={error}
      interval={interval}
    />
  );
};
